import { Appointment, StartWorkItemDto } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { appointmentKeys } from "../appointment.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";
import { appointmentApi } from "../service";
import { auditLogKeys } from "../../../audit-log";

export function useStartAppointment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      workOrderId,
      body,
    }: {
      id: number;
      workOrderId?: string;
      body?: StartWorkItemDto;
    }) => {
      const { data } = await appointmentApi.start(id, body);
      return { appointment: data as Appointment, workOrderId };
    },
    onSettled: (_data, _err, vars) => {
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all });
      // Starting moves the block to the actual travel/start — the calendar reads it via
      // `GET /schedule`, see useCompleteAppointment.
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
      if (vars?.workOrderId) {
        queryClient.invalidateQueries({ queryKey: auditLogKeys.byWorkOrder(vars.workOrderId) });
      }
    },
  });
}
